module.exports = __webpack_public_path__ + "img/longevity_icon.png";